import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const StandAloneIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 130 80">
    <svg>
      <path fill="#000" fillOpacity={0.12} d="M7.29 46h115.421v1H7.29z" />
      <rect
        opacity={0.4}
        x={7.897}
        y={22}
        width={48.598}
        height={16}
        rx={8}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={7.574}
        y={55}
        width={115}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
    </svg>
  </SvgIcon>
);

export default StandAloneIcon;
